import { graphql } from 'react-relay';

const homepageRootQuery = graphql`
    query homepageRootQuery(
        $hasRecentlyViewedItems: Boolean!
        $isMobile: Boolean!
        $homepageId: String!
        $userId: String!
        $hasUserId: Boolean!
        $isTrade: Boolean!
        $recentlyViewedItemIds: [String]
        $isClient: Boolean!
    ) {
        viewer {
            ...HpRespLayout_viewer
            informationalContent @skip(if: $isTrade) {
                visible
            }
            homepage(rootId: $homepageId) {
                ...getHomePageMetaContent_homepage @relay(mask: false)
            }
        }
    }
`;

const homepageVariables = {
    hasRecentlyViewedItems: false,
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    isTrade: false,
    recentlyViewedItemIds: [],
    userIds: [],
    isClient: false,
};

export { homepageRootQuery, homepageVariables };
